export default "__VITE_ASSET__D6SfQS7k__"